import {
  BeneficiaryFormValues,
  IBeneficiaryPayload
} from '@epi-models/pages/Beneficiaries';

export const getBeneficiaryPayload = (
  values: BeneficiaryFormValues
): IBeneficiaryPayload => {
  return {
    personId: values.personId,
    personalId: values.personalId,
    firstName: values.firstName,
    lastName: values.lastName,
    emailAddress: values.emailAddress,
    costCenter: values.costCenter,
    employeeNumber: values.employeeNumber,
    floor: values.floor,
    department: values.department,
    region: values.region,
    startOfBenefit: values.entitled,
    EmploymentType: values.EmploymentType,
    benefitPercentage:
      values.EmployeePercentage === ''
        ? null
        : Number(values.EmployeePercentage),
    benefitLunchMaxWorkingDays:
      values.DaysForLunari === '' ? null : Number(values.DaysForLunari),
    endOfBenefit: values.endOfBenefit,
    endOfFunds: values.endOfFunds,
    groupId: values.groupId
  };
};
